import './Footer.css'

function Footer()
{
    return <>
    <div className='footer'>
        <h3>Goodbye, see you next time!! ^-^</h3>
        <p>
            This website was fully development by me (Marco) using the React.js framework.<br/>
            More info on the GitHub repository.
        </p>
    </div>
    </>
}

export default Footer;